import { Card, SkeletonItem } from "@fluentui/react-components";

import { Flex } from "@tdp/common/fluentV9MigrationComponents";

import { useOverviewCardStyles } from "./AppValidationDetails.styles";

export const OverviewHeroCardShimmer: React.FC = () => {
  const classes = useOverviewCardStyles()
  return <Card className={classes.card}>
    <Flex fill gap="gap.large" column>
      <SkeletonItem style={{ width: "30%" }}></SkeletonItem>
      <Flex gap="gap.medium" column>
        <SkeletonItem style={{ width: "100%" }}></SkeletonItem>
        <SkeletonItem style={{ width: "80%" }}></SkeletonItem>
        <SkeletonItem style={{ width: "30%" }}></SkeletonItem>
      </Flex>
      <Flex gap="gap.medium" column>
        <SkeletonItem style={{ width: "100%" }}></SkeletonItem>
        <SkeletonItem style={{ width: "80%" }}></SkeletonItem>
      </Flex>
      <Flex gap="gap.medium" column>
        <SkeletonItem style={{ width: "30%" }}></SkeletonItem>
      </Flex>
    </Flex>
  </Card>
}
